<!--
  네비게이션
  TICKET 이벤트

  @since: 2021-06-09
  @updater: wj_tams_dev02
-->

<template>
  <li v-if="ticketEvent"
      :class="`title dep-none navi-notice-group ${isShowNav ? '' : 'navi-notice-group-footer'} ${isMouseOver ? 'on': ''}`">
    <div class="list-inline">
      <a
          ref="ticketEventAnchor"
          class="navi-ticket"
          @click="onShowTicketEventTooltip"
          @mouseover="isMouseOver = true"
          @mouseleave="isMouseOver = false"
      >
        <div :class="['badge badge-lv1', {'active-new': ticketEventInfoCount > 0}]" :style="getAlertStyle"><span class="badge-text">{{ getTicketEventText }}</span></div>
        <div :class="['badge badge-lv2 badge-white', {'active-new': ticketEventInfoCount > 0}]"><span class="badge-text">{{ getTicketEventText }}</span></div>
        <div class="badge badge-lv3 badge-info" :style="getAlertStyle"><span class="badge-text">{{ getTicketEventText }}</span></div>
      </a>

      <a href="javascript:;"
         v-if="isShowNav"
         :style="iconTextStyle"
         class="alert-notice-cursor"
         @click="onShowTicketEventTooltip"
         @mouseover="isMouseOver = true"
         @mouseleave="isMouseOver = false"
      >{{ $t('cmn.ticketEvent') }}</a>

      <q-tooltip v-show="!showTicketEventTooltip"
                 self="center left"
                 anchor="top right"
                 class="bs bs-q-tooltip bs-q-tooltip-default"
                 :offset="[5, 15]"
      >
        <template v-if="typeof ticketEventInfo === 'undefined'">
          <span>{{ $t('msg.mainNavigation_tooltip_noTicketEvent') }}</span>
        </template>

        <template v-else>
          <span>{{ $t('da.ticketEventSummaryView') }}</span>
        </template>
      </q-tooltip>

    </div>

    <div v-show="showTicketEventTooltip"
         v-global-hide="onCloseTicketEventTooltip">
      <template v-if="typeof ticketEventInfo !== 'undefined'">
        <div ref="ticketEventTooltip"
             class="q-tooltip animate-popup-up bs bs-q-tooltip bs-q-tooltip-default"
             style="z-index: 9999 !important;">
          <div class="marB5">
            <div class="inline-block">
              <span>{{ $t('msg.mainNavigation_tooltip_ticketEvent') }}</span>
            </div>
            <q-btn @click="onClickShowAlertEventPopup" color="dark" flat="flat"
                   class="bs bs-q-btn-xs bs-q-btn-flat-type bs-q-btn-info-setup float-right">
              <!--장비 현황 보기-->
              <span class="bs-q-btn-text">{{$t('da.viewDeviceStatus')}}</span>
              <q-icon class="bs-q-btn-icon bs-q-btn-icon-info-setup"/>
            </q-btn>
          </div>

          <div class="portlet-borderNone"></div>

          <table class="bs-table table-box-type">
            <colgroup>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
              <col width="100px"/>
            </colgroup>

            <thead>
            <tr>
              <th>Total</th>
              <th v-for="(item, idx) in tooltipHeaderText">
                <div class="inline-block">
                  <span>{{ item }}</span>
                </div>
              </th>
            </tr>
            </thead>

            <tbody>
            <tr>
              <td class="table-cell-align-center"
                  v-for="(item, key, index) in ticketEventInfo"
                  :style="getLevelStyle(ticketColor[index])">
                <div class="inline-block">
                  <span :title="getScaleToolTip(item)">{{ getScale(item) }}</span>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
      </template>
    </div>
    <!-- 외곽 가시 알림 -->
    <template v-if="false">
      <div class="page-alert page-alert-top" ref="alertLayout" :style="getAlertStyle"/>
      <div class="page-alert page-alert-right" ref="alertLayout" :style="getAlertStyle"/>
      <div class="page-alert page-alert-bottom" ref="alertLayout" :style="getAlertStyle"/>
      <div class="page-alert page-alert-left" ref="alertLayout" :style="getAlertStyle"/>
    </template>
  </li>
</template>

<script>
  import { separateByComma, kmgtConverter, getColorLuminance } from '~/utils/charts'
  import { setToolTipPosition, parsePosition } from '~/utils/toolTipUtils'

  // plugins
  import Hub from '~/plugins/global-event-hub'

  import { createNamespacedHelpers } from 'vuex'
  const { mapState } = createNamespacedHelpers('common/navigation')
  // const { mapState: commonMapState, mapMutations: commonMapMutations, mapActions: commonMapActions } = createNamespacedHelpers('common/common/')
  const { mapState: commonMapState, mapActions: commonMapActions } = createNamespacedHelpers('common/common/')

  export default {
    name: 'TicketEventStatus',
    components: {},
    directives: {},
    mixins: [],
    props: {},
    data () {
      return {
        isMouseOver: false,
        checkAlertTimer: void 0,
        showBorderTicketEvent: false,
        tooltipHeaderText: [this.$t('da.ticketEvent_publish_title'), this.$t('da.ticketEvent_receipt_title'),
          this.$t('da.ticketEvent_analysis_title'), this.$t('da.ticketEvent_reAnalysis_title'), this.$t('da.ticketEvent_complete_title')],
        showTicketEventTooltip: false,
        ticketColor: ['#eac8ff', '#e6e7ff', '#cde886', '#6fd7b6', '#4ea4d6', '#2a72cb']
      }
    },
    computed: {
      ...mapState([
        'ticketEvent'
      ]),
      ...commonMapState([
        'ticketEventInfo',
        'preventLogoutAfterTimer',
        'isShowNav'
      ]),
      isNewWindow () {
        return this.$route.query.newWindow
      },
      iconTextStyle () {
        try {
          let res = {}
          switch (_.get(String(this.getTicketEventText), ['length'], 0)) {
            case 1:
            case 2:
              res['padding-left'] = '10px !important'
              break
            case 3:
              res['padding-left'] = '15px !important'
              break
            case 4:
              res['padding-left'] = '21px !important'
              break
          }
          return res
        } catch (e) {
          return {}
        }
      },
      ticketEventInfoCount () {
        // 티켓 이벤트 갯수
        return (typeof this.ticketEventInfo === 'undefined') ? 0 : this.ticketEventInfo.ticket_summary_total
      },
      getTicketEventText () {
        return this.ticketEventInfoCount > 999 ? '999+' : this.ticketEventInfoCount
      },
      getAlertStyle () {
        try {
          let info, low, medium, high, critical, eventColor
          // 레벨 확인
          const eventList = this.ticketEventInfo.event_list
          critical = eventList[0]
          high = eventList[1]
          medium = eventList[2]
          low = eventList[3]
          info = eventList[4]

          // 레벨에 따른 Class 설정
          if (critical.old_cnt > 0 || critical.new_cnt > 0) {
            eventColor = critical.color
          } else if (high.old_cnt > 0 || high.new_cnt > 0) {
            eventColor = high.color
          } else if (medium.old_cnt > 0 || medium.new_cnt > 0) {
            eventColor = medium.color
          } else if (low.old_cnt > 0 || low.new_cnt > 0) {
            eventColor = low.color
          } else if (info.old_cnt > 0 || info.new_cnt > 0) {
            eventColor = info.color
          }

          return {
            'background-color': eventColor,
            color: getColorLuminance(eventColor)
          }
        } catch (e) {
          const infoColor = '#4491e7'
          return {
            'background-color': infoColor,
            color: getColorLuminance(infoColor)
          }
        }
      }
    },
    methods: {
      ...commonMapActions([
        'getTicketEventInfo'
      ]),
      movePage (path) { // Main Navigation Move 이동 메소드
        this.$emit('movePage', path)
      },
      onClickShowAlertEventPopup () { // 상세 현황 보기, 팝업 클릭
        if (typeof this.ticketEventInfo !== 'undefined') {
          const alertLogURI = '/logReport/prismLog/ticketBrowser'
          this.movePage(alertLogURI)
          this.showTicketEventTooltip = false
        }
      },
      getScale (value) { // 팝업창 테이블 숫자 표시 템플릿
        return typeof value === 'number' ? ((value > 999) ? '999+' : kmgtConverter(value)) : 0
      },
      getScaleToolTip (value) { // 팝업창 테이블 숫자 ToolTip 표시 템플릿
        return typeof value === 'number' ? separateByComma(value) : 0
      },
      getLevelStyle (bgColor) { // 등급에 따른 색상 표시
        const background = bgColor
        const color = getColorLuminance(background)

        return {
          background,
          color
        }
      },
      setAlertTimer () { // start alarm timer
        this.checkAlertTimer = setTimeout(this.detectTicketEvent, 60000)
      },
      stopAlertTimer () { // end alarm timer
        if (typeof this.checkAlertTimer !== 'undefined') {
          clearTimeout(this.checkAlertTimer)
        }
      },
      async detectTicketEvent () { // Ticket Event 정보 조회
        if (typeof this.checkAlertTimer !== 'undefined') {
          clearTimeout(this.checkAlertTimer)
        }

        await this.getTicketEventInfo() // Ticket Event 정보 조회

        // 자동 세션 아웃 시간 만료 후 timer 호출 방지
        if (!this.preventLogoutAfterTimer) {
          this.setAlertTimer()
        } else {
          if (typeof this.checkAlertTimer !== 'undefined') {
            clearTimeout(this.checkAlertTimer)
          }
        }
      },
      onShowTicketEventTooltip () { // 마크 클릭했 을 때 작동
        try {
          if (typeof this.ticketEventInfo !== 'undefined') {
            this.showTicketEventTooltip = true
            this.$nextTick(() => {
              setToolTipPosition({
                el: this.$refs.ticketEventTooltip,
                animate: true,
                offset: [-40, 0],
                anchorEl: this.$refs.ticketEventAnchor,
                anchorOrigin: parsePosition('top left'),
                selfOrigin: parsePosition('bottom left')
              })
            })
          }
        } catch (e) {
          this.showTicketEventTooltip = false
        }
      },
      onCloseTicketEventTooltip () { // 팝업 창이 닫혔 을 때
        this.showTicketEventTooltip = false
      }
    },
    beforeCreate () {},
    created () {},
    beforeMount () {},
    mounted () {
      window.addEventListener('resize', this.onCloseTicketEventTooltip)
      window.addEventListener('scroll', this.onCloseTicketEventTooltip)

      if (!this.isNewWindow) {
        this.$nextTick(() => {
          // 알람 이벤트 감지
          this.detectTicketEvent()

          // 설정 복구 도중, 전역 타이머 동작되지 않도록 타이머 관리열 추가
          Hub.addTimer('ticketEventTimer', {
            start: this.setAlertTimer,
            stop: this.stopAlertTimer
          })
        })
      }
    },
    beforeUpdate () {},
    updated () {},
    activated () {},
    deactivated () {},
    beforeDestroy () {},
    beforeRouteLeave (to, from, next) {
      if (typeof this.checkAlertTimer !== 'undefined') {
        clearTimeout(this.checkAlertTimer)
      }
      window.removeEventListener('resize', this.onCloseTicketEventTooltip)
      window.removeEventListener('scroll', this.onCloseTicketEventTooltip)
      next()
    },
    destroyed () {},
    errorCaptured () {},
    watch: {}
  }
</script>

<style scoped>
  .alert-notice-cursor {
    cursor: pointer;
  }
  .table-cell-align-center {
    text-align: center
  }
  .badge-text {
    color: inherit !important;
  }

  /* Safari 4.0 - 8.0 */
  @-webkit-keyframes flash {
    0% {opacity: 0.1}
    10% {opacity: 0.2}
    25% {opacity: 0.5}
    40% {opacity: 0.7}
    70% {opacity: 0.9}
    80% {opacity: 0.85}
    100% {opacity: 0.6}
  }

  /* Standard syntax */
  @keyframes flash {
    0% {opacity: 0.1}
    10% {opacity: 0.2}
    25% {opacity: 0.5}
    40% {opacity: 0.7}
    70% {opacity: 0.9}
    80% {opacity: 0.85}
    100% {opacity: 0.6}
  }

  /*TAMS 가시 알림*/
  .page-alert {
    position: fixed;
    z-index: 9999;
    -webkit-animation-name: flash;
    -webkit-animation-duration: 1.2s;
    -webkit-animation-iteration-count: infinite;
    animation-name: flash;
    animation-duration: 1.2s;
    animation-iteration-count: infinite;
  }
  .page-alert.page-alert-top {
    left: 0;
    top: 0;
    width: 100vw;

    height: 11px;
    /*height: 10px;*/
  }
  .page-alert.page-alert-right {
    right: 0;
    top: 11px;
    height: calc(100% - 22px);
    width: 11px;

    /*top: 10px;*/
    /*height: calc(100% - 20px);*/
    /*width: 10px;*/
  }
  .page-alert.page-alert-bottom {
    left: 0;
    bottom: 0;
    width: 100vw;

    height: 11px;
    /*height: 10px;*/
  }
  .page-alert.page-alert-left {
    left: 0;
    top: 11px;
    height: calc(100% - 22px);
    width: 11px;
  }
  .list-inline {
    display: inline !important;
  }
  .inline-block {
    display: inline-block !important;
  }
  .inline-block span {
    display: unset !important;
  }
</style>


